module.exports = __webpack_public_path__ + "ddbc4f80576b1ed78178b6915cf531c5.fbx";